<template>
  <div class="fs14 lh30">
    <div class="flex">
      <p class="w300">姓名：{{ info.patName }} 性别：{{ info.patGender|sexFilter }} 年龄：{{ info.patAge }}岁 </p>
      <p>身份证号：{{ info.patIdcard }}</p></div>
    <div class="flex">
      <p class="w300">家庭联系人：{{ info.familyContactsName }} {{ info.familyContactsMobile }}</p>
      <p>申请医生：<b>{{ info.initDocName }} {{ info.initDocMobile }}</b></p>
    </div>
    <p>疾病主诉：{{ info.patComplaint }}</p>
    <p>诊断：{{ info.tentativeDiagnosis }}</p>
    <p>目前状况 / 诊疗经过 / 病史：</p>
    <p>{{ info.treatmentProcess }}</p>
    <div class="flex">
      <p>患方是否知情同意转院意见：</p>
      <p>{{ info.transferHospital ? '已知情同意' : '不同意' }}</p>
    </div>
    <!--    <p>会诊资料：</p>
        <div v-if="info.consultAvatarUrl">
          <p>会诊单：</p>
          <img class="consultAvatar" :src="info.consultAvatarUrl" alt="">
        </div>-->
    <div class="flex">
      <p>会诊意见附件：</p>
      <template v-for="(item,index) in info.attaList">
        <el-image v-if="item.fileType==='IMAGE'" :src="item.url"
                  style="width: 60px; height: 60px; margin-left: 15px"
                  :key="index" :preview-src-list="[item.url]"></el-image>
      </template>
    </div>

    <div class="flex">
      <p>附件资料：</p>
      <ul class="ml15">
        <template v-for="(item,index) in info.attaList">
          <li :key="index" v-if="item.fileType!=='IMAGE'">
            <span>{{ item.attaFileName }} </span>
            <a :href="item.url" :download="item.attaFileName" class="color_main">下载</a>
          </li>
        </template>
      </ul>
    </div>

    <div class="flex">
      <p>图片资料：</p>
      <el-image :src="info.consultAvatarUrl" v-if="info.consultAvatarUrl"
                style="width: 60px; height: 60px; margin-left: 15px"
                :key="index" :preview-src-list="[info.consultAvatarUrl]"></el-image>
    </div>

    <div class="flex jcc" v-if="query.aspectUser==='init'&&isAID_ADM">
      <el-button type="primary" plain size="mini" @click="$emit('modify')">修改
      </el-button>
    </div>
  </div>
</template>

<script>
import {sexFilter} from "@/common/lib/filters";

export default {
  name: "base-form",
  filters: {sexFilter},
  props: {
    info: {
      type: Object,
      default: () => Object.create(null)
    },
    query: {
      type: Object,
      default: () => Object.create(null)
    }
  },
}
</script>

<style scoped>
.uploader-icon {
  width: 60px;
  height: 60px;
  display: block;
  text-align: center;
  line-height: 60px;
  border: 1px dashed #f0f0f0;
}

.consultAvatar {
  width: 100px;
  height: 100px;
}
</style>
